import React from 'react';
import { withRouter } from 'react-router-dom';
import WithSessionContext from '../../HOC/WithSessionContext';
import AppBar from './AppBar';

const NavBar = (props) => {
    return <AppBar {...props}/>
}
export default withRouter(WithSessionContext(NavBar))